import EmployeeAvatar from "../../../employee/avatar/employee-avatar";
import { getNameObject } from "../../../../utility/event.utils";
import { removeUnderScoreWithCaptialize } from "../../../../utility/utility";
import { Button } from "antd";
import React, { useContext } from "react";
import Locale from "../../../../core/locale/locale";
import dayjs from "dayjs";
import { CalendarDays, Gift, HeartPlus, PartyPopper, SquareCheck } from "lucide-react";
import UserLoginContext from "../../../../context/userLoginContext";

interface ICelebrationListProps {
    employeeId: string,
    name: string,
    profilePhoto?: string,
    eventType: string,
    onClick: () => void;
    key: string,
    showWishButton: boolean;
    date: string;
}

function getEventStatus(date: string){
    const dateA = dayjs(date);
    const today = dayjs();
    if (dateA.isSame(today, 'date')) {
        return 'Today'

    } else if (dateA.isBefore(today, 'date')) {
        return 'Past'

    } else {
        return 'Upcoming'
    }
}

const CelebrationList = (props: ICelebrationListProps) => {
    const {user} = useContext(UserLoginContext);
    const selfCelebration = user.employeeId === props.employeeId;


    return (
        <div className={`dashboard-celebration-card__list-item ${getEventStatus(props.date).toLowerCase()}`}
             key={props.employeeId}
             onClick={(e) => {
                 e.stopPropagation();
                 if (props.showWishButton) {
                     props.onClick();
                 }
             }}>
            <div className={'celebration-card-avatar-and-name'}>
                <EmployeeAvatar
                    name={getNameObject(props.name)}
                    thumbnailId={props?.profilePhoto}/>
                <div className={'celebration-name-and-type'}>
                    <span className="employee-name">{props.name}</span>
                    <div className={'tags-wrapper'}>
                        <span
                            className={`event-type ${props.eventType}`}>
                        {removeUnderScoreWithCaptialize(props.eventType)}
                    </span>
                        <span className={`event-status ${getEventStatus(props.date).toLowerCase()}`}>
                                 {getEventStatus(props.date)}
                        </span>
                    </div>


                </div>
            </div>

            {props.showWishButton ? (
                <>
                    {
                        selfCelebration ? (
                                <Button className={'dashboard-celebration-card__wish-button'}>
                                    <HeartPlus/> View Wishes
                                </Button>
                            ) :
                            (
                                <Button className={'dashboard-celebration-card__wish-button'}>
                                    <HeartPlus/> Send Wish
                                </Button>
                            )
                    }
                </>
            ) : (
                <div className={'dashboard-celebration-card__date-info'}>
                    <CalendarDays
                        className={'calendar-icon'}
                    />
                    {props.date ? dayjs(props.date).format(Locale.displayDateAndMonth) : ""}
                </div>
            )
            }
        </div>
    )
}

export default CelebrationList;
